import Axios from '@/axios';

// 查询商品
export const GetAllOrders = data => {
  return Axios({
    url: '/face/web/good-order/index',
    method: 'POST',
    type: 'json',
    data
  })
}
// 查询所有未开票的支付订单
export const GetAllUnInvoiceOrders = data => {
  return Axios({
    url: '/face/web/good-order/index_for_invoice',
    method: 'POST',
    type: 'json',
    data
  })
}
